import React from "react";

const ProductDetailsSkeleton = () => {
  return (
    <div className="container mx-auto p-6">
      <div className="flex flex-wrap lg:flex-nowrap gap-6">
        {/* Loading skeleton for the product image */}
        <div className="flex-1">
          <div className="mb-4 flex justify-center">
            <div className="w-64 h-80 sm:w-72 sm:h-96 bg-gray-300 animate-pulse"></div>
          </div>
          <div className="flex flex-wrap gap-2 justify-center">
            {Array(4)
              .fill()
              .map((_, index) => (
                <div
                  key={index}
                  className="w-16 h-16 sm:w-24 sm:h-24 bg-gray-300 animate-pulse"
                ></div>
              ))}
          </div>
        </div>

        {/* Loading skeleton for the product details */}
        <div className="flex-1">
          <div className="h-8 w-1/2 bg-gray-300 animate-pulse mb-4"></div>
          <div className="h-6 w-3/4 bg-gray-300 animate-pulse mb-4"></div>

          <div className="mt-4">
            <div className="flex flex-wrap gap-2 mb-4">
              {Array(3)
                .fill()
                .map((_, index) => (
                  <div
                    key={index}
                    className="p-2 w-24 h-10 sm:w-32 bg-gray-300 animate-pulse rounded-lg"
                  ></div>
                ))}
            </div>

            <div className="mt-4">
              <p className="h-6 w-1/2 bg-gray-300 animate-pulse mb-4"></p>

              {Array(2)
                .fill()
                .map((_, index) => (
                  <div
                    key={index}
                    className="flex flex-wrap justify-around items-center mb-4"
                  >
                    <div className="h-6 w-1/4 bg-gray-300 animate-pulse"></div>
                    <div className="flex-1">
                      <div className="flex flex-wrap gap-2 mb-2">
                        {Array(4)
                          .fill()
                          .map((_, i) => (
                            <div
                              key={i}
                              className="w-16 h-10 sm:w-20 bg-gray-300 animate-pulse rounded-lg"
                            ></div>
                          ))}
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="flex flex-wrap gap-2">
                        {Array(4)
                          .fill()
                          .map((_, i) => (
                            <div
                              key={i}
                              className="w-16 h-10 sm:w-20 bg-gray-300 animate-pulse rounded-lg"
                            ></div>
                          ))}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsSkeleton;
